import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/

function createRule() {
  // Match any images that aren't inside single backticks
  var mdImageRegex = /(?<!`)!\[[^\]]*\]\([^\)]+\)(?!`)/g;
  var validParentTokens = ['th_open', 'td_open', 'list_item_open'];
  return function media(State) {
    var getUrl = function getUrl(str) {
      var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
      if (res.ok) {
        var href = State.md.normalizeLink(res.str);
        if (State.md.validateLink(href)) {
          return href;
        }
      }
      return '';
    };
    var createMediaTokens = function createMediaTokens(url) {
      var mediaSingleOpen = new State.Token('media_single_open', '', 1);
      var media = new State.Token('media', '', 0);
      media.attrs = [['url', getUrl(url)], ['type', 'external']];
      var mediaSingleClose = new State.Token('media_single_close', '', -1);
      return [mediaSingleOpen, media, mediaSingleClose];
    };
    var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
      if (!str || str.length === 0) {
        return [];
      }
      var inlineBefore = new State.Token('inline', '', 1);
      inlineBefore.content = str;
      inlineBefore.children = [];
      return [].concat(_toConsumableArray(openingTokens), [inlineBefore], _toConsumableArray(closingTokens));
    };
    var processedTokens = [];
    var newTokens = State.tokens.reduce(function (tokens, token, i, arr) {
      if (token.type === 'inline' && mdImageRegex.test(token.content)) {
        var openingTokens = [];
        var cursor = i - 1;
        var previousToken = arr[cursor];
        var subTree = [];

        // Loop backwards through the tokens until a valid parent token is found
        while (previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1) {
          openingTokens.unshift(previousToken);
          cursor--;
          previousToken = arr[cursor];
        }

        // If the previous token is not a valid parent token, add it to the start of the opening tokens array
        if (validParentTokens.indexOf(previousToken.type) === -1) {
          openingTokens.unshift(previousToken);
        } else {
          cursor++;
        }

        // Create closing tokens for each opening token and reverse the array
        var closingTokens = openingTokens.map(function (token) {
          return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
        }).reverse();
        var matches = token.content.match(mdImageRegex);

        // Process all images in the inline token
        var inlineContentStack = token.content;
        matches.forEach(function (match) {
          var start = inlineContentStack.indexOf(match);
          var contentBefore = inlineContentStack.substring(0, start);
          inlineContentStack = inlineContentStack.substring(start + match.length);

          // Add the inline tokens and media tokens to the subtree
          subTree = [].concat(_toConsumableArray(subTree), _toConsumableArray(createInlineTokens(contentBefore, openingTokens, closingTokens)), _toConsumableArray(createMediaTokens(match)));
        });

        // If there is any remaining content in the stack, add the inline tokens to the subtree
        if (inlineContentStack.length) {
          subTree = [].concat(_toConsumableArray(subTree), _toConsumableArray(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
        }
        processedTokens = [].concat(_toConsumableArray(processedTokens), _toConsumableArray(closingTokens.map(function (c) {
          return c.type;
        })));
        tokens = [].concat(_toConsumableArray(tokens.slice(0, cursor)), _toConsumableArray(subTree));
      } else if (processedTokens.indexOf(token.type) !== -1) {
        // Ignore token if it's already processed
        processedTokens.splice(processedTokens.indexOf(token.type), 1);
      } else {
        tokens.push(token);
      }
      return tokens;
    }, []);
    State.tokens = newTokens;
    return true;
  };
}
export default (function (md) {
  md.core.ruler.before('inline', 'media', createRule());
});